<ng-container>
	<base-display [alignment]="alignment()" [smallLetters]="s()" [bigLetters]="b()" [unit]="unit()" [showScale]="false"></base-display>
</ng-container>

